import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from '../Grid'

import { Heading, Text } from '../Type'

interface ErrorProps {
  title?: string
  message?: string
  children?: React.ReactNode
}

const Container = styled(Flex).attrs(props => ({
  flexWrap: 'wrap',
  alignItems: 'center',
  textAlign: 'center',
  ...props
}))`
  min-height: 100vh;
`

const Error = ({ title, message, children, ...rest }: ErrorProps): React.ReactNode => (
  <Container {...rest}>
    <Box m="auto">
      <Box width={1}>
        <Heading level="md">{title || 'There was an error loading the page'}</Heading>
      </Box>
      {!message || (
        <Box mt={3}>
          <Text level="sm">{message}</Text>
        </Box>
      )}
      {!children || <Box mt={3}>{children}</Box>}
    </Box>
  </Container>
)

export default Error
